import { FormFooter as BaseFormFooter, FormFooterSubmit } from 'components';
import { useTranslation } from 'libs/i18n';

import { useFormContext } from '../../forms/formFM1Form';

interface Props {
  submitLoading?: boolean;
}

export const FormFooter = ({ submitLoading }: Props) => {
  const { t } = useTranslation();
  const { submitDisabled, dirty } = useFormContext();

  return (
    <BaseFormFooter>
      <FormFooterSubmit
        disabled={submitDisabled || !dirty}
        label={t('formFM1.submitButtonTitle')}
        loading={submitLoading}
      />
    </BaseFormFooter>
  );
};
